/** Slugs que ningún local puede tomar (el demo usa `demo` y lo crea el seed). */
export const RESERVED_SLUGS = [
    'demo',
    'api',
    'admin',
    'www',
    'menu',
    'app',
    'assets',
    'static',
    'public',
];
export const SLUG_MIN_LENGTH = 3;
export const SLUG_MAX_LENGTH = 40;
const SLUG_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
/** "Heladería La Esquina" → "heladeria-la-esquina" */
export function slugify(input) {
    return input
        .normalize('NFD')
        .replace(/\p{M}/gu, '')
        .toLowerCase()
        .replace(/&/g, ' y ')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, SLUG_MAX_LENGTH)
        .replace(/-+$/g, '');
}
/** Formato válido: 3–40 caracteres, minúsculas, números y guiones simples. No chequea reservados. */
export function isValidSlug(slug) {
    return slug.length >= SLUG_MIN_LENGTH && slug.length <= SLUG_MAX_LENGTH && SLUG_RE.test(slug);
}
export function isReservedSlug(slug) {
    return RESERVED_SLUGS.includes(slug.toLowerCase());
}
//# sourceMappingURL=slug.js.map